import { useState } from "react";
export function usePaginationAt(page, allItems, perPage = 10) {
    const pages = Math.max(1, Math.ceil(allItems.length / perPage));
    const currentPage = Math.min(Math.max(1, page), pages);
    const itemsSlice = allItems.slice((currentPage - 1) * perPage, currentPage * perPage);
    return [itemsSlice, currentPage, pages];
}
export function usePagination(allItems, perPage = 10, initialPage = 1) {
    const [page, setPage] = useState(initialPage);
    const [itemsSlice, currentPage, pages] = usePaginationAt(page, allItems, perPage);
    return [itemsSlice, currentPage, setPage, pages];
}
//# sourceMappingURL=usePagination.js.map